module.exports = __webpack_public_path__ + "static/media/bl5.81960e4c.jpg";